import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faCopyright } from '@fortawesome/free-solid-svg-icons';
import "./Footer.css"
import {motion} from "framer-motion"

function Footer() {
      // Replace these with actual URLs
  const navLinks = [
    { name: 'Privacy policy', url: '/' },
    { name: 'Terms of services', url: '/' },
    { name: 'Contact Us', url: '/' },
  ];

  // Replace these with actual URLs
  const socialLinks = [
    { icon: faTwitter, url: 'https://twitter.com/yourhandle' },
    { icon: faInstagram, url: 'https://instagram.com/yourhandle' },
  ];

  const currentYear = new Date().getFullYear();
  const companyName = "House of Dhanushdhari";
    return (
        <div className='footer'>
            <motion.hr
                style={{ backgroundColor: "black", height: "2px", border: "none",margin:"0px auto" }}
                initial={{ width: 0, opacity: 0 }}
                whileInView={{ width: "80%", opacity: 1 }}
                transition={{ duration: 1.2, delay: 0.5 }}
                viewport={{ once: true }}
            />

            
    <footer className="app-minimal-footer">
      
      {/* Navigation Links Section */}
      <nav className="app-minimal-footer__nav-container">
        {navLinks.map((link) => (
          <a key={link.name} href={link.url} className="app-minimal-footer__nav-link">
            {link.name}
          </a>
        ))}
      </nav>

      {/* Social Media Icons Section */}
      <div className="app-minimal-footer__social-icons">
        {socialLinks.map((link, index) => (
          <a key={index} href={link.url} target="_blank" rel="noopener noreferrer" className="app-minimal-footer__social-link">
            <FontAwesomeIcon icon={link.icon} size="lg" />
          </a>
        ))}
      </div>

      {/* Copyright Information Section */}
      <div className="app-minimal-footer__copyright">
        <FontAwesomeIcon icon={faCopyright} size="sm" className="app-minimal-footer__copyright-icon" />
        <span>All rights reserved by {companyName} {currentYear}.</span>
      </div>
    </footer>
        </div>
    )
}

export default Footer